import { ToggleGroup, ToggleGroupItem } from '@repo/ui/components'
import { LucideIcon } from 'lucide-react'
import { Container } from './Container'

type ToggleListProps = {
  name: string
  title: string
  options: { value: string; label: string; icon?: LucideIcon }[]
  selectedOptions: string[]
  setSelectedOptions: React.Dispatch<React.SetStateAction<string[]>>
}

export default function MultipleToggleList(props: ToggleListProps) {
  const hasOptionsSelected = props.selectedOptions?.length > 0

  const handleReset = () => {
    props.setSelectedOptions([])
  }

  return (
    <Container
      title={props.title}
      isResetVisible={hasOptionsSelected}
      onReset={handleReset}
      hasOptionsSelected={hasOptionsSelected}
    >
      <ToggleGroup
        type="multiple"
        value={props.selectedOptions}
        onValueChange={props.setSelectedOptions}
        className="flex flex-wrap justify-start gap-2"
      >
        {props.options.map((option) => (
          <ToggleGroupItem size="button" key={option.value} value={option.value} variant="outline">
            {option.icon && <option.icon />}
            {option.label}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </Container>
  )
}
